//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//로딩 액션
import { AjaxLoading } from '../../../actions/Interactions/loading';
//데이터 API 목록
import { dataUrl } from '../dataUrl';

import { formCheck } from '../lib/formCheck';

var numOfPaging = 200;
var currentAdvId = null;
var currentNaverAccId = null;
var checkedType = {
	btn  : 'Compare',
	list : 'Compare'
};
var biddingList = null; // 페이지 열릴 때 서버에서 가져온 데이터 저장 변수
var checkedBiddingList = null; // 체크박스 체크 된 데이터 임시 저장 변수
var activeKeywordList = null; // 자동 키워드 리스트
var keywordListInBidFavorite = null; // 즐겨찾기에 들어가있는 키워드 리스트 초기에 저장
var campaignList = null;
var haveBidFavoriteGroups = null; // 가지고 있는 즐겨찾기 그룹 초기에 저장
var initCheck = false; // 페이지 초기화 여부
var pagingIdx = 0; // 페이징 처리용
var currentCs1Value = 'NA'; // 기준 값 선택되어 검색했는지
var currentCs2Value = 'NA'; // 비교 값 선택되어 검색했는지
var currentCheckedBtnCount = 0; //
var currentCampaignsStr = null; // 현재 캠페인 리스트 문자열

// 차후 스크롤용 변수
var $TABLE1 = null;
var $TABLES_OUTER = null;

const AMT_MIN_VALUE = 70; // 입찰최소값
const AMT_MAX_VALUE = 100000; // 입찰최대값
var OPTION_MAX_BID_AMT = AMT_MAX_VALUE; // 일괄변경레이어 옵션 입찰최대값 저장변수





// 검색 처리용
var currentSearchKeyword = null; // 현재 검색 된 키워드명
var currentSearchType = null; // 현재 검색 된 키워드의 검색 타입(like, equal, start)
var advanceSearchUse = false; // 고급검색 사용 여부
var advSrchGroupOptions = null; // 고급검색 유형선택 초기에 서버에서 가져와 저장

var filter_fields = ''; // 고급검색 유형들 저장 변수(노출수, 클릭율 등)
var filter_operations = ''; // 고급검색 범위 저장 변수(구간, 이상, 이하)
var filter_values = ''; // 인풋박스 저장 변수

var $currentAdvSearchRow = null;

// 정렬 처리용
var currentSort = null; // ASC, DESC
var currentSortField = null; // 현재 정렬 된 필드

// 하나의 행의 입찰가 레이어 띄울 때 그 행의 키워드 ID 임시 저장할 변수
var clickedSingleKwdId = null;


export const biddingFunc = {
	init:function() {	},

	initReptJobHistoryDatesByAdvId : function(advId){

		$TABLE1 = $('.table_01');
		$TABLES_OUTER = $('#result-tables-outer');

		currentAdvId = advId;
		haveBidFavoriteGroups = {};
		keywordListInBidFavorite = {};
		activeKeywordList = {};
		currentNaverAccId = $('#advKey').val();
		favoriteFunc.setAdvKeyDirectly(currentNaverAccId);
		biddingFunc.initReptJobHistory();

		var dataApi = dataUrl.biddingAPI('GET', 'historyDate', currentAdvId + '&result_cd=complete');
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setReptJobHistoryDates);

		biddingFunc.refreshKeywordListInBidFavorite();

		biddingFunc.initAdvancedSearch();

		dataApi = dataUrl.alwaysAPI('GET', 'subMenu', currentAdvId);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setHaveBidFavoriteGroups);

		dataApi = dataUrl.biddingAPI('GET', 'activeKeywordList', currentAdvId);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setActiveKeywordList);
	},

	// 리스트 가져오는 파라미터 설정
	makeGetBiddingListDataApiUrl : function(){
		var params = "?adv_id=" + currentAdvId;
		params += "&start=" + pagingIdx*numOfPaging;
		params += "&limit=" + numOfPaging;
		params += "&origin=" + currentCs1Value;
		if( checkedType.list == 'Compare' ){
			params += "&control=" + currentCs2Value;
		}

		if( currentSearchKeyword != null ){
			params += "&search_type=" + currentSearchType;
			params += "&search_field=" + currentSearchKeyword;
		}

		if( advanceSearchUse == true ){
			params += "&filter_fields=" + filter_fields.substring(0,filter_fields.length-1);
			params += "&filter_operations=" + filter_operations.substring(0, filter_operations.length-1);
			params += "&filter_values=" + filter_values.substring(0, filter_values.length-1);
		}

		if( currentSort != null && currentSortField != null){
			params += "&sort=" + currentSort;
			params += "&sort_field=" + currentSortField;
		}

		if( currentCampaignsStr != null ){
			params += "&campaign_ids=" + currentCampaignsStr;
		}

		return params;
	},

	initReptJobHistory : function(cs1Value, cs2Value, searchType, searchKeyword){
		biddingList = {};
		checkedBiddingList = {};
		initCheck = true;
		pagingIdx = 0;
		currentCheckedBtnCount = 0;
		currentCs1Value = (cs1Value == undefined || cs1Value == null ? 'NA' : cs1Value);
		currentCs2Value = (cs2Value == undefined || cs2Value == null ? 'NA' : cs2Value);
		currentSearchType = (searchType == undefined || searchType == null ? null : searchType);
		currentSearchKeyword = (searchKeyword == undefined  || searchKeyword == null ? null : searchKeyword);
		currentSort = null;
		currentSortField = null;

		if( currentCs1Value != 'NA' ){
			$('.main_search_wrap').show();
		}else{
			$('.main_search_wrap').hide();
		}
		$('.bidding_list_wrap').hide();

		if( currentSearchKeyword != null ){
			$('.bidding_none_wrap').hide();
			$('.none_search_wrap').show();
		}else{
			$('.bidding_none_wrap').show();
			$('.none_search_wrap').hide();
		}
	},

	setReptJobHistoryDates : function(result){
		var rjhArr = result.data;
		var rjh = null;
		var options = "<option value='NA'>선택</option>";

		if( rjhArr != undefined && rjhArr != null ){
			for(var idx=0; idx<rjhArr.length; idx++){
				rjh = rjhArr[idx];
				options += "<option data-id='"+ rjh.id +"' data-update-at='"+ rjh.update_at +"' value='"+ rjh.job_group_ser +"'>"+ rjh.work_name +"</option>"
			}
			$('#choice-select-1, #choice-select-2').html(options);
		}else{
			$('.bidding-sub-wrap').hide();
			$('.bidding_none_wrap').show();
		}
	},

	clickCampaignField : function(){
		biddingFunc.setCampaignLiHtml();
		var $cvo = $('#campaign-view-outer');
		if( $cvo.css('display') == 'none' ){
			$cvo.show();
		}else{
			$cvo.hide();
		}
	},

	initCampaignList : function(result){
		currentCampaignsStr = null;
		campaignList = {};
		var campaigns = result.data;
		var length = campaigns.length;
		var campaign = null;
		for(var idx=0; idx<length; idx++){
			campaign = campaigns[idx];
			if( campaign.campaignTp == 'WEB_SITE' && campaign.status == 'ELIGIBLE' ){
				campaignList[ campaign.nccCampaignId ] = campaign;
				campaignList[ campaign.nccCampaignId ]['checked'] = false;
			}
		}
	},

	setCampaignLiHtml : function(){
		var campaignHtml = '';
		var oneCamp = null;
		for(var cId in campaignList){
			oneCamp = campaignList[cId];
			campaignHtml += '<li><input class="cLi-checkboxes" type="checkbox" '+ (oneCamp.checked?'checked':'') +' id="cLi-'+ oneCamp.nccCampaignId +'" data-campaign-id="'+ oneCamp.nccCampaignId +'"><label for="cLi-'+ oneCamp.nccCampaignId +'">'+ oneCamp.name +'</label></li>';
		}
		$('#campaign-view-ul').html( campaignHtml );
	},

	clickCampaignFieldConfirm : function(uncheckAll){
		currentCampaignsStr = '';
		var cId = null;
		if( uncheckAll != true ){
			$('.cLi-checkboxes:checked').each(function(i){
				cId = $(this).data('campaign-id');
				campaignList[ cId ]['checked'] = true;
				currentCampaignsStr += cId + ',';
			});
		}

		if( cId != null ){
			currentCampaignsStr = currentCampaignsStr.substring(0, currentCampaignsStr.length-1);
		}else{
			currentCampaignsStr = null;
		}

		biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, currentSearchType, currentSearchKeyword);
		var dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},

	setActiveKeywordList : function(result){
		activeKeywordList = result.data;
	},

	clickDateRadioBtn : function(type){
		checkedType.btn = type;
		if( type == 'Compare' ){
			document.getElementById('choice-select-2').disabled = false;
		}else{
			document.getElementById('choice-select-2').disabled = true;
		}
	},

	clickConfirmForBiddingList : function(){
		var $cs1 = $('#choice-select-1');
		var cs1UpdateAt = $cs1.find('option:selected').data('update-at');
		var cs1Value = $cs1.val();
		var cs2Value = $('#choice-select-2').val() == 'NA' ? undefined : $('#choice-select-2').val();

		if( cs1Value == 'NA' ){
			alert('기준데이터를 선택해주세요.');
			return;
		}

		if( checkedType.btn == 'Compare' ){
			if( cs2Value == undefined ){
				alert('비교데이터를 선택해주세요.');
				return;
			}
		}

		// 기본 검색에 이전에 검색했던 텍스트 제거
		$('#bidding-default-search-keyword').val('');

		// 기준데이터 업데이트 날짜 설정
		$('#reference-update-at-txt').html( new Date(cs1UpdateAt).toISOString().slice(0,19).replace('T', ' ') );
		checkedType.list = checkedType.btn;

		// 해당 광고주 캠페인 목록 초기화
		var dataApi = dataUrl.biddingAPI('GET','NaverApiCampaign', currentNaverAccId);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.initCampaignList);

		// 고급검색초기화
		biddingFunc.initAdvancedSearch();
		biddingFunc.initReptJobHistory(cs1Value, cs2Value);

		dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},

	toggleSortArea : function(obj){
		var $this = $(obj);
		var sf = $this.data('sf');

		if( $this.find('.media_array').length != 0 ){
			$('.media_array').remove();
		}else{
			$('.media_array').remove();
			var layer = '';
			layer += '<div class="media_array hide active">';
			layer += '	<ul>';
			layer += '		<li><button type="button" '+ (currentSortField==null&&currentSort==null?'class="on"':'') +'onclick="biddingFunc.sortBiddingList(this);">기본정렬</button></li>';
			layer += '		<li><button type="button" '+ (currentSortField==sf&&currentSort=='ASC'?'class="on"':'') +' onclick="biddingFunc.sortBiddingList(this, \'ASC\');">오름차순</button></li>';
			layer += '		<li><button type="button" '+ (currentSortField==sf&&currentSort=='DESC'?'class="on"':'') +' onclick="biddingFunc.sortBiddingList(this, \'DESC\');">내림차순</button></li>';
			layer += '	</ul>';
			layer += '</div>';
			$this.append(layer);
		}
	},

	clickExcelDownload : function(){
		if( confirm('전체 데이터를 엑셀로 다운받으시겠습니까?') ){
			var excelDownloadParam = "?type=integrate&adv_id=" + currentAdvId;
			excelDownloadParam += "&work_name=" + $('#choice-select-1').find('option:selected').text();
			excelDownloadParam += "&origin=" + currentCs1Value;
			if( checkedType.list == 'Compare' ) excelDownloadParam += "&control=" + currentCs2Value;
			window.open(dataUrl.biddingAPI('GET','excel', excelDownloadParam), 'zero_frame');
		}
	},

	sortBiddingList : function(obj, sort){
		var $this = $(obj);
		var sortField = $this.closest('th').data('sf');
		biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, currentSearchType, currentSearchKeyword);

		if( sort == undefined ){
			currentSort = null;
			currentSortField = null;
		}else{
			currentSort = sort;
			currentSortField = sortField;
		}

		$('.field-sort-btn').not($this.addClass('on')).removeClass('on');
		var dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},


	clickShowAll : function(){
		$('#bidding-default-search-keyword').val('');
		biddingFunc.initAdvancedSearch();
		biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value);

		var dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},

	biddingResultDivOnScroll : function(){
		var leftOffset = $TABLES_OUTER.scrollLeft();
		$TABLE1.css('left', leftOffset);
	},

	setBiddingList : function(result){
		var $table1 = $('.table_01');
		var $table2 = $('.table_02');
		var $table3 = $('.table_03');
		var $table4 = $('.table_04');

		if( initCheck == true ){
			initCheck = false;
			$('#error-wrap').hide();
			$table1.find('tbody').empty();
			$table2.find('tbody').empty();
			$table3.find('tbody').empty();
			$table4.find('tbody').empty();
			$('#total_cnt_strong').text(result.total_cnt);
		}

		biddingFunc.checkMoreBiddingListBtn(result.total_cnt);

		// Campaign Filter Area Hide
		$('#campaign-view-outer').hide();


		var biddingArr = result.data;

		if( biddingArr == 'ERROR' ){
			$('#error-wrap').show();
			$('.none_search_wrap').hide();
			$('.bidding_none_wrap').hide();
			return;
		}

		var showTableSumWidth = 0;
		var length = biddingArr.length;
		var defaultRows = '';
		var resultRows = '';
		var refRows = '';
		var compRows = '';
		if( length > 0 ){

			var compareAdd = checkedType.list == 'Compare' ? '_res':'';
			$('#table2-thead th').each( function(idx){
				var $this = $(this);
				var tempSf = $this.data('temp-sf');
				$this.data('sf', tempSf + compareAdd);
			});

			for(var idx=0; idx<length; idx++){
				biddingList[ biddingArr[idx].kwd_id ] = biddingArr[idx];
				defaultRows += biddingFunc.makeOneDefaultRow(biddingArr[idx]);
				resultRows += biddingFunc.makeOneResultRow(biddingArr[idx], checkedType.list=='Lookup'?'':'_res');

				if( checkedType.list == 'Compare' ){
					refRows += biddingFunc.makeOneReferenceRow(biddingArr[idx]);
					compRows += biddingFunc.makeOneComparisonRow(biddingArr[idx]);
				}
			}

			$table1.find('tbody').append(defaultRows);
			$table2.find('tbody').append(resultRows);
			if( checkedType.list == 'Lookup' ){
				$table2.find('h3').text('조회결과');
				$table3.hide();
				$table4.hide();
			}else{ // checkedType.list == 'Compare'
				$table2.find('h3').text('비교결과');
				$table3.show().find('tbody').append(refRows);
				$table4.show().find('tbody').append(compRows);
			}
			$('.bidding_list_wrap').show();
			$('.bidding_none_wrap').hide();
			$('.bidding-sub-wrap').show();
			$('.none_search_wrap').hide();


			// 동적으로 보여지는 테이블 너비 확인하여 테이블 감싸고있는 wrap div width 세팅
			var $dynamicGroups = checkedType.list == 'Lookup' ? $('.dynamic-group-1'):$('.dynamic-group-2');
			var wit = 0;
			for(var idx=0; idx<$dynamicGroups.length; idx++){
				showTableSumWidth += $($dynamicGroups[idx]).width();
			}

			//console.log(showTableSumWidth);
			var DTW = $('#default-table').width();
			//$('.table_01').width(DTW)
			$('.table_02').css('margin-left',DTW);
			$('.dynamic-follow-default-table').css('width',DTW);
			$('#bidding-list-width-outer').width(showTableSumWidth+15);


		}else{ // 검색 결과 없을 경우
			if( initCheck == false ){
				$('.biding_list_wrap').hide();
				$('.main_search_wrap').show();
				$('.none_search_wrap').show();
			}else{
				$('.bidding-sub-wrap').show();
				$('.bidding_none_wrap').hide();
				$('.none_search_wrap').show();
			}
		}
	},




	makeOneDefaultRow : function(rowData){
		var activeCheck = activeKeywordList.hasOwnProperty(rowData.kwd_id);
		var row = "";
		row += "<tr id='row-"+ rowData.kwd_id +"' data-kwd_id='"+ rowData.kwd_id +"'>";
		row +=    "<td><input type='checkbox' onclick='biddingFunc.changeNeedCheckedBtn();' class='list-check "+ (activeCheck?'active-row':'') +"' data-kwd_id='"+ rowData.kwd_id +"' id='tender" + rowData.id +"'><label for='tender" + rowData.id +"'></label></td>";
		row +=     "<td>";
		row +=        "<div class='on_off_btn' onclick='biddingFunc.oneBidStatusBtnClick(\""+ rowData.kwd_id +"\");'>";
		row +=            "<button class='status-on-btn "+ (rowData.status=='ELIGIBLE'?'on':'') +"'>ON</button>";
		row +=            "<button class='status-off-btn "+ (rowData.status=='ELIGIBLE'?'':'on') +"'>OFF</button>";
		row +=        "</div>";
		row +=    "</td>";
		row +=    "<td align='left'>" + rowData.campaign_nm + "</td>";
		row +=    "<td align='left'>" + rowData.adgroup_nm + "</td>";
		row +=    "<td align='left' class='keyword_contents'>";
		row +=        "<a href='https://search.naver.com/search.naver?query="+ rowData.kwd_nm +"' target='_blank'><button class='pc'></button></a>";
		row +=        "<a href='https://m.search.naver.com/search.naver?query="+ rowData.kwd_nm +"' target='_blank'><button class='mobile'></button></a>";
		row +=        "<span>" + rowData.kwd_nm + "</span>";
		row +=    "</td>";
		row +=    "<td align='left' data-id='" + rowData.id + "'>";
		row +=        "<div class='bid_wrap'>";
		row +=            	"<div class='bid_icon'>";
		row +=                "<button type='button' class='bid_01' "+ (activeCheck?'disabled':'') + " data-name='bidChange' onclick='biddingFunc.setSingleKwdId(\""+ rowData.kwd_id +"\"); layerPopup.open(this, this.id);'></button>";
		row +=                "<button type='button' class='bid_02' "+ (activeCheck?'disabled':'') + " list-btn-modify' onclick='biddingFunc.clickOneCurrentAmtModifyBtn(this);'></button>";
		row +=           		  "<div class='bid_price'>" + numberWithCommas(rowData.cur_bid_amt) + "</div>";
		row +=            	"</div>";
		row += 						"<div class='active-btn-area hide'>";
		row +=							"<form onsubmit='biddingFunc.clickOneCurrentAmtSaveBtn(this); return false;'>";
		row +=								"<button type='button' onclick='biddingFunc.clickOneCurrentAmtSaveBtn(this);' class='list-btn-save'>저장</button>";
		row += 								"<button type='button' class='list-btn-cancer' onclick='biddingFunc.clickOneCurrentAmtCancelBtn(this);'>취소</button>";
		row += 								"<input type='number' value='" + numberWithCommas(rowData.cur_bid_amt) + "' class='active-input-area'>";
		row +=							"</form>"
		row += 						"</div>";
		row +=    "</td>";
		row +=    "<td>";
		row +=			activeCheck?'자동':'수동';
		row +=    "</td>";
		row +=    "<td class='condition-"+ rowData.id +"'>";
		row += 		"<button type='button' class='his_btn' data-key='" + rowData.kwd_id + "' data-name='history' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";

		//row +=        "<button class='his_btn' data-id='" + rowData.id +"' data-name='history' onclick='layerPopup.open(this, this.id);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";
		row +=    "</td>";
		row += "</tr>";
		return row;
	},

	makeOneResultRow : function(rowData, type){
		var row = '';

		var avgRnk = eval('rowData["avg_rnk'+type+'"]');
		if( avgRnk < 0 ){
			avgRnk = '<span style="color:red">▼</span> '+ avgRnk.toString().replace('-','');
		}else if( avgRnk > 0 ){
			avgRnk = '<span style="color:blue">▲</span> ' + avgRnk;
		}

		row += "<tr>";
		row += "<td>" + eval('numberWithCommas(rowData["imp_cnt'+type+'"])') + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["clk_cnt'+type+'"])') + "</td>";
		row += "<td>" + eval('rowData["ctr'+type+'"]') + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["recent_avg_cpc'+type+'"])') + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["sales_amt'+type+'"])') + "</td>";
		row += "<td>" + avgRnk + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["neo_kwd_ccnt'+type+'"])') + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["neo_price'+type+'"])') + "</td>";
		row += "<td>" + eval('rowData["cvtr'+type+'"]') + "</td>";
		row += "<td>" + eval('numberWithCommas(rowData["cvpc'+type+'"])') + "</td>";
		row += "<td>" + eval('rowData["roas'+type+'"]') + "%</td>";
		row += "</tr>";
		return row;
	},

	makeOneReferenceRow : function(rowData){
		var row = '';
		row += "<tr>";
		row += "<td>" + numberWithCommas(rowData.imp_cnt_org) + "</td>";
		row += "<td>" + numberWithCommas(rowData.clk_cnt_org) + "</td>";
		row += "<td>" + rowData.ctr_org + "%</td>";
		row += "<td>" + numberWithCommas(rowData.recent_avg_cpc_org) + "</td>";
		row += "<td>" + numberWithCommas(rowData.sales_amt_org) + "</td>";
		row += "<td>" + rowData.avg_rnk_org + "</td>";
		row += "<td>" + numberWithCommas(rowData.neo_kwd_ccnt_org) + "</td>";
		row += "<td>" + numberWithCommas(rowData.neo_price_org) + "</td>";
		row += "<td>" + rowData.cvtr_org + "</td>";
		row += "<td>" + numberWithCommas(rowData.cvpc_org) + "</td>";
		row += "<td>" + rowData.roas_org + "</td>";
		row += "</tr>";
		return row;
	},

	makeOneComparisonRow : function(rowData){
		var row = '';
		row += "<tr>";
		row += 	"<td>" + numberWithCommas(rowData.imp_cnt_ctl) + "</td>";
		row += 	"<td>" + numberWithCommas(rowData.clk_cnt_ctl) + "</td>";
		row += 	"<td>" + rowData.ctr_ctl + "%</td>";
		row += 	"<td>" + numberWithCommas(rowData.recent_avg_cpc_ctl) + "</td>";
		row += 	"<td>" + numberWithCommas(rowData.sales_amt_ctl) + "</td>";
		row += 	"<td>" + rowData.avg_rnk_ctl + "</td>";
		row += 	"<td>" + numberWithCommas(rowData.neo_kwd_ccnt_ctl) + "</td>";
		row += 	"<td>" + numberWithCommas(rowData.neo_price_ctl) + "</td>";
		row += 	"<td>" + rowData.cvtr_ctl + "</td>";
		row += 	"<td>" + numberWithCommas(rowData.cvpc_ctl) + "</td>";
		row += 	"<td>" + rowData.roas_ctl + "%</td>";
		row += "</tr>";
		return row;
	},






	// 현재 입찰가 관련 Start
	clickOneCurrentAmtModifyBtn : function(obj){
		var $this = $(obj);
		var $parent = $this.closest('tr');
		var kwdId = $parent.data('kwd_id');
		$parent = $parent.find('.bid_wrap');
		$parent.find('.active-input-area').val( biddingList[kwdId].cur_bid_amt );
		$parent.find('.bid_icon').hide();
		$parent.find('.active-btn-area').show();
	},
	clickOneCurrentAmtCancelBtn : function(obj){
		var $this = $(obj);
		var $parent = $this.closest('tr');
		var kwdId = $parent.data('kwd_id');
		$parent = $parent.find('.bid_wrap');
		var $bidPrice = $parent.find('.bid_icon').show().find('.bid_price').text( numberWithCommas(biddingList[kwdId].cur_bid_amt) );
		$parent.find('.active-btn-area').hide();

		$bidPrice.css('color','red');
		setTimeout(function(){
			$bidPrice.css('color','');
		},1000);
	},
	clickOneCurrentAmtSaveBtn : function(obj){
		var $this = $(obj);
		var $parent = $this.closest('tr');
		var kwdId = $parent.data('kwd_id');
		checkedBiddingList = {};
		checkedBiddingList[kwdId] = biddingList[kwdId];
		biddingFunc.setBeforeBidAmt();
		biddingFunc.setCurBidAmtBySame($parent.find('.active-input-area').val());
		biddingFunc.updateBidAmt();
	},

	bidAmtRound : function(value){
		var result = Math.floor(Math.round(Number(value)/10))*10;
		if( result < AMT_MIN_VALUE ){
			result = AMT_MIN_VALUE;
		}else if( result > AMT_MAX_VALUE ){
			result = AMT_MAX_VALUE;
		}
		return result;
	},

	setBeforeBidAmt : function(){
		for(var kwdId in checkedBiddingList){
			checkedBiddingList[kwdId].before_bid_amt = checkedBiddingList[kwdId].cur_bid_amt;
		}
	},
	setCurBidAmtBySame : function(changeValue){
		changeValue = (OPTION_MAX_BID_AMT < changeValue ? OPTION_MAX_BID_AMT : changeValue);
		for(var kwdId in checkedBiddingList){
			checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(changeValue);
			$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
		}
		OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
	},
	setCurBidAmtByIncrease : function(changeValue, changeValueType){
		var calcValue = 0;
		if( changeValueType == '원' ){
			for(var kwdId in checkedBiddingList){
				calcValue = checkedBiddingList[kwdId].before_bid_amt + Number(changeValue);
				calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
				$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
			}
		}else{ // changeValueType == '%'
			for(var kwdId in checkedBiddingList){
				calcValue = checkedBiddingList[kwdId].before_bid_amt * (1+(Number(changeValue)/100));
				calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
				$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
			}
		}
		OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
	},
	setCurBidAmtByDecrease : function(changeValue, changeValueType){
		var calcValue = 0;
		if( changeValueType == '원' ){
			for(var kwdId in checkedBiddingList){
				calcValue = checkedBiddingList[kwdId].before_bid_amt - Number(changeValue);
				calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
				$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
			}
		}else{ // changeValueType == '%'
			for(var kwdId in checkedBiddingList){
				calcValue = checkedBiddingList[kwdId].before_bid_amt * (1-(Number(changeValue)/100));
				calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
				$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
			}
		}
		OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
	},
	setCurBidAmtByNaverAPI : function(result){
		var midAmts = result.data;
		var calcValue = 0;
		for(var kwdId in midAmts){
			calcValue = midAmts[kwdId].bid;
			calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
			checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
			$('#preview-' + kwdId).val( numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt) );
		}
		OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
	},

	updateBidAmt : function(){
		if( confirm('변경하시겠습니까?') == false ){
			return;
		}
		var sendData = {
			adv_id : currentAdvId,
			keywords : new Array()
		}
		for(var key in checkedBiddingList){
			sendData.keywords.push(checkedBiddingList[key]);
		}
		var dataApi = dataUrl.favoriteAPI('POST','update_bid','');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveCurrentAmt, sendData);
	},
	afterSaveCurrentAmt : function(result){
		var returnList = result.data;
		var curKwdId = null;
		var $changeRow = null;
		for(var idx=0; idx<returnList.length; idx++){
			curKwdId = returnList[idx].nccKeywordId;
			biddingList[curKwdId] = checkedBiddingList[curKwdId];
			$changeRow = $('#row-' + curKwdId);
			$changeRow.find('.list-btn-cancer').trigger('click');
		}
		$('.fixed-pop').fadeOut(200,function(){ $(this).clearQueue(); });
	},

	setSingleKwdId : function(kwdId){
		clickedSingleKwdId = kwdId;
	},

	openBidAmtPopup : function(){
		if( clickedSingleKwdId != null ){
			checkedBiddingList = {};
			checkedBiddingList[clickedSingleKwdId] = biddingList[clickedSingleKwdId];
			clickedSingleKwdId = null;
		}else{
			biddingFunc.setCheckedRows(true);
		}

		if( Object.keys(checkedBiddingList).length == 0 ){
			alert('자동입찰 키워드만 선택되었습니다.\n다시 선택해주세요.');
			return;
		}

		biddingFunc.setBeforeBidAmt();
		var rows = '';
		for(var kwdId in checkedBiddingList){
			rows += biddingFunc.makeOneBidAmtRow( checkedBiddingList[kwdId] );
		}
		$('#bid_amt_preview_table').find('tbody').html(rows);
		$('.fixed-pop').fadeIn(200,function(){ $(this).clearQueue(); });
	},

	makeOneBidAmtRow : function(rowData){
		var row = '';
		row += '<tr>';
		row += '	<td>';
		row += '		<div>';
		row += '			<a href="https://search.naver.com/search.naver?query='+ rowData.kwd_nm +'" target="_blank"><button><img src="/image/common/keyword_icon.png" alt="돋보기버튼"></button></a>';
		row += '		</div>';
		row += '		<div>'+ rowData.kwd_nm +'</div>';
		row += '	</td>';
		row += '	<td>';
		row += '		<div><input type="text" value="'+ numberWithCommas(rowData.cur_bid_amt) +'" readonly></div>';
		row += '	</td>';
		row += '	<td data-kwd_id="'+ rowData.kwd_id +'">';
		row += '		<div>';
		row += '			<button class="lp4-btn-toggle-off" onclick="biddingFunc.clickBidAmtModifyBtnInPreview(this);"><img src="/image/common/bid_icon_02.png" alt="변경버튼"></button>';
		row += '			<button class="lp4-btn-toggle-on" onclick="biddingFunc.clickBidAmtStoreBtnInPreview(this);" style="display:none;"><img src="/image/common/bid_icon_03.png" alt="저장버튼"></button>';
		row += '			<button class="lp4-btn-toggle-on" onclick="biddingFunc.clickBidAmtCancelBtnInPreview(this);" style="display:none;"><img src="/image/common/bid_icon_04.png" alt="엑스버튼"></button>';
		row += '		</div>';
		row += '		<div><input type="text" id="preview-'+ rowData.kwd_id +'" placeholder="최소 '+ AMT_MIN_VALUE +'원" value="'+ numberWithCommas(rowData.cur_bid_amt) +'" class="change_input" readonly></div>';
		row += '	</td>';
		row += '</tr>';
		return row;
	},

	clickBidAmtModifyBtnInPreview : function(obj){
		var $this = $(obj).hide();
		var $parent = $this.closest('td');
		var kwdId = $parent.data('kwd_id');
		$parent.find('.lp4-btn-toggle-on').show();
		var $input = $parent.find('.change_input');
		$input.val(checkedBiddingList[kwdId].cur_bid_amt).prop('readonly',false);
	},
	clickBidAmtStoreBtnInPreview : function(obj){
		var $this = $(obj);
		var $parent = $this.closest('td');
		var kwdId = $parent.data('kwd_id');
		var $input = $parent.find('.change_input');
		biddingFunc.setCurBidAmtBySame($input.val());
		biddingFunc.clickBidAmtCancelBtnInPreview(obj);
	},
	clickBidAmtCancelBtnInPreview : function(obj){
		var $this = $(obj);
		var $parent = $this.closest('td');
		var kwdId = $parent.data('kwd_id');
		$parent.find('.lp4-btn-toggle-on').hide();
		$parent.find('.lp4-btn-toggle-off').show();
		var $input = $parent.find('.change_input');
		$input.val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt)).prop('readonly',true);
	},

	clickBidAmtPreviewBtn : function(){
		var $radio = $('.amt-choices:checked');
		var $parentLi = $radio.closest('li');
		var changeValue = $parentLi.find('.change-value').val();
		var changeValueType = $parentLi.find('.change-value-type').val();

		if( changeValue == '' ){
			alert('입찰가를 입력해주세요.');
			return;
		}

		// 최대입찰가 클릭되어 있을 시 Start
		var optionChecked = $('#option').prop('checked');
		var $optionMaxBidAmt = $('#option-max-bid-amt');
		var optionMaxBidAmtVal = $optionMaxBidAmt.val();

		if( optionChecked ){
			if( optionMaxBidAmtVal == '' ){
				alert('옵션) 최대입찰가를 입력해주세요.');
				return;
			}else if( Number(optionMaxBidAmtVal) < AMT_MIN_VALUE || AMT_MAX_VALUE < Number(optionMaxBidAmtVal) ){
				alert('최대입찰가는 최소 '+ AMT_MIN_VALUE +'원에서 최대 100,000원입니다.');
				return;
			}else{
				OPTION_MAX_BID_AMT = Number(optionMaxBidAmtVal);
			}
		}else{
			OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
		}
		// 최대입찰가 클릭되어 있을 시 End

		switch( $radio.val() ){
			case 'SAME' :
					biddingFunc.setCurBidAmtBySame(changeValue);
				break;
			case 'INCREASE' :
					biddingFunc.setCurBidAmtByIncrease(changeValue, changeValueType);
				break;
			case 'DECREASE' :
					biddingFunc.setCurBidAmtByDecrease(changeValue, changeValueType);
				break;
			case 'MID_AMT' :
			case 'AVG_AMT' :
					var params = '?na_customer=' + currentNaverAccId;
							params +='&view_bid_type=' + changeValue;
							params +='&na_kwd_sers=' + biddingFunc.makeCheckedBiddingListKeywordKeyCommaStr();
					var dataApi = dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
					AjaxLoading.pageLoading();
					ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setCurBidAmtByNaverAPI);
				break;
		}
	},

	makeCheckedBiddingListKeywordKeyCommaStr : function(){
		var na_kwd_sers = '';
		for(var key in checkedBiddingList){
			na_kwd_sers += key + ',';
		}
		na_kwd_sers = na_kwd_sers.substring(0, na_kwd_sers.length-1);
		return na_kwd_sers;
	},

	clickCheckedBidAmtSaveBtn : function(){
		biddingFunc.updateBidAmt();
	},
	// 현재 입찰가 관련 End



	// 더보기 버튼
	clickMoreBiddingListBtn : function(obj){
		var dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},

	// 더보기 버튼 노출 여부
	checkMoreBiddingListBtn : function(total_cnt){
		if( (++pagingIdx)*numOfPaging <= total_cnt ){
			$('#data-more-area').css('display','');
		}else{
			$('#data-more-area').css('display','none');
		}
	},


	// 체크 된 행 세팅
	setCheckedRows : function(notActive){
		var $checkedList = $('.list-check:checked');
		if( notActive == true ){
			$checkedList = $checkedList.not('.active-row');
		}
		var cKwdId = null;
		checkedBiddingList = {};
		$checkedList.each(function(index){
			cKwdId = $(this).data('kwd_id');
			checkedBiddingList[ cKwdId ] = JSON.parse(JSON.stringify(biddingList[ cKwdId ]));
		});
	},





	// 즐겨찾기 관련 Start
	refreshKeywordListInBidFavorite : function(){
		var dataApi = dataUrl.favoriteAPI('GET', 'groupKey', "?adv_id=" + currentAdvId);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setKeywordListInBidFavorite);
	},
	setKeywordListInBidFavorite : function(result){
		keywordListInBidFavorite = result.data;
	},
	setHaveBidFavoriteGroups : function(result){
		var groups = result.data.groups;
		var oneGroup = null;
		for(var key in groups){
			oneGroup = groups[key];
			haveBidFavoriteGroups[ oneGroup['id'] ] = oneGroup['name'];
		}
	},
	changeNeedCheckedBtn : function(){
		if( $('.list-check:checked').length == 0 ){
			$('.need-clicked-btn').prop('disabled',true);
		}else{
			$('.need-clicked-btn').prop('disabled',false);
		}
	},

	deleteCheckedOneRow : function(obj){
		var $this = $(obj);
		if( confirm('삭제하시겠습니까?') ){
			delete checkedBiddingList[ $this.data('kwd_id') ];
			$this.closest('li').remove();
			biddingFunc.setSelectedKeywordCount();
		}
	},

	setSelectedKeywordCount : function(){
		$('#bf-selected-keyword-count').text("("+ Object.keys(checkedBiddingList).length +")");
	},

	openBidFavoritePopUp : function(){
		biddingFunc.setCheckedRows(false);
		biddingFunc.setSelectedKeywordCount();
		var rows = '';

		var $oldSelectbox = $('#bf-old-select');
		var options = '';
		for(var key in haveBidFavoriteGroups ){
			options += "<option value='"+ key +"'>" + haveBidFavoriteGroups[key] + "</option>";
		}
		$oldSelectbox.html(options);

		for(var key in checkedBiddingList){
			rows += biddingFunc.makeOneBidFavoriteRow( checkedBiddingList[key] );
		}
		$('.bf-selected-keywords-ul').html(rows);
		$('.fixed-pop').fadeIn(200,function(){ $(this).clearQueue(); });
	},

	makeOneBidFavoriteRow : function(rowData){
		var row = '';
		row += "<li>"
		row += "	<div>";
		row += "		<button data-kwd_id='"+ rowData.kwd_id +"' onclick='biddingFunc.deleteCheckedOneRow(this);'>";
		row += "			<img src='image/common/bid_icon_04.png'>";
		row += "		</button>";
		row += "	</div>";
		row += "	<div>";
		row += 			rowData.kwd_nm + "( " + rowData.adgroup_nm + " > " + rowData.campaign_nm + " )";
		if ( keywordListInBidFavorite[rowData.kwd_id] != undefined ){
			row += " ( " + keywordListInBidFavorite[rowData.kwd_id] + " )"
		}
		row += "	</div>";
		row += "</li>";
		return row;
	},
	clickSaveBidFavoriteBtn : function(){
		var groupType = $('.bf-bid-favorite-radio:checked').val();
		var newGroupNameVal = $('#bf-new-input').val();
		var oldGroupSelectedVal = $('#bf-old-select option:checked').val();
		var keywordsArr = new Array();
		var sendData = {
			group : {
				advs_id : currentAdvId,
			}
		}

		if( groupType == 'new' ){
			if( newGroupNameVal == ''){
				alert('신규 그룹명을 입력해주세요.');
				return;
			}
			sendData['group']['name'] = newGroupNameVal;
		}else{ // groupType == 'old'
			sendData['group']['id'] = oldGroupSelectedVal;
		}

		for(var key in checkedBiddingList){
			keywordsArr.push( checkedBiddingList[key] );
		}
		sendData['keywords'] = keywordsArr;
		var dataApi = dataUrl.favoriteAPI('POST', 'keywordPush', '');
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveBidFavorite, sendData);
	},
	afterSaveBidFavorite : function(result){
		if( result.success ){
			if( result.data == 'OVER_BY_ADV_ID'){
				alert('광고주별 최대 즐겨찾기 개수를 초과하였습니다.');
			}else if( result.data == 'OVER_BY_ALL'){
				alert('입찰 솔루션에 등록 가능한 즐겨찾기 갯수가 초과하였습니다.');
			}else{
				biddingFunc.refreshKeywordListInBidFavorite();
				alert('즐겨찾기가 추가되었습니다.');
				$('.fixed-pop').hide();
			}
		}
	},
	// 즐겨찾기 관련 End






	// 키워드 상태 관련 Start
	oneBidStatusBtnClick : function(kwd_id){
		var keyword = biddingList[kwd_id];
		keyword['before_status'] = keyword['status'];
		keyword['status'] = (keyword['status'] == 'ELIGIBLE' ? 'PAUSED' : 'ELIGIBLE');
		var keywords = new Array();
		keywords.push(keyword);
		biddingFunc.updateBidStatus(keywords)
	},
	checkedBidStatusBtnClick : function(changeStatus){
		biddingFunc.setCheckedRows();
		var keyword = null;
		var keywords = new Array();
		for(var key in checkedBiddingList){
			keyword = checkedBiddingList[key];
			keyword['before_status'] = keyword['status'];
			keyword['status'] = changeStatus;
			keywords.push(keyword);
		}
		biddingFunc.updateBidStatus(keywords);
	},
	updateBidStatus : function(keywords){
		if( confirm('변경하시겠습니까?') == false){
			return;
		}
		var sendData = {
			adv_id : currentAdvId,
			keywords : keywords
		}
		var dataApi = dataUrl.favoriteAPI('POST', 'updateStatus', '');
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterUpdateBidStatus, sendData);
	},
	afterUpdateBidStatus : function(result){
		var returnList = result.data;
		var kwdId = null;
		var changedStatus = returnList[0].status;

		for(var idx=0; idx<returnList.length; idx++){
			kwdId = returnList[idx].nccKeywordId;
			biddingList[kwdId]['status'] = changedStatus;
			$('#row-' + kwdId).find('.status-on-btn').attr('class','status-on-btn ' + (changedStatus=='ELIGIBLE'?'on':'') );
			$('#row-' + kwdId).find('.status-off-btn').attr('class','status-off-btn ' + (changedStatus=='PAUSED'?'on':'') );
		}
	},
	// 키워드 상태 관련 End






	// 검색 관련 Start
	initAdvancedSearch : function(){
		advanceSearchUse = false;
		filter_fields = '';
		filter_operations = '';
		filter_values = '';
		$('#toggleAdvancedSearchBtn').text('고급검색열기');
		var param = "?field_name=group";
		var dataApi = dataUrl.biddingAPI('GET', 'addSelectField', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setAdvancedSearchGroupOptions);
	},
	setAdvancedSearchGroupOptions : function(result){
		advSrchGroupOptions = result.data;
		$('#bidding-advanced-search').hide().html(biddingFunc.makeOneAdvancedSearchRow('add'));
	},

	makeOneAdvancedSearchRow : function(btnType){
		var row = '';
		row  = '<div class="add_contents">';
		row += '		<div class="add_select">';
		row += '				<select class="type_select" onchange="biddingFunc.onChangeAdvancedGroupSelect(this);">';
		row += '          <option disabled selected value="NA">유형 선택</option>';
		for(var idx=0; idx<advSrchGroupOptions.length; idx++){
			if( checkedType.list == 'Lookup' ){
				row += '        <option '+ (advSrchGroupOptions[idx].field_name!="origin"?'disabled':'') +' value="'+ advSrchGroupOptions[idx].field_name +'">'+ advSrchGroupOptions[idx].field_label +'</option>';
			}else{
				row += '				<option value="'+ advSrchGroupOptions[idx].field_name +'">'+ advSrchGroupOptions[idx].field_label +'</option>';
			}
		}
		row += '				</select>';
		row += '				<select class="data_select">';
		row += '          <option disabled selected value="NA">유형을 먼저 선택해주세요.</option>';
		row += '				</select>';
		row += '				<select class="section_select" onchange="biddingFunc.onChangeAdvancedSection(this);">';
		row += '						<option value="compare" selected>구간</option>';
		row += '						<option value="more">이상</option>';
		row += '						<option value="less">이하</option>';
		row += '				</select>';
		row += '		</div>';
		row += '		<div class="add_input">';
		row += '				<input type="number" class="adv-srch-value">';
		row += '				<span class="not-compare">~</span>';
		row += '				<input class="not-compare adv-srch-value" type="number">';
		row += '		</div>';
		row += '		<button type="button" class="add_btn box_model" data-btn-type="'+ btnType +'" onclick="biddingFunc.clickAdvancedAMBtn(this);">'+ (btnType == 'add' ? '+':'-') +'</button>';
		row += '</div>';
		return row;
	},
	toggleAdvancedSearch : function(){
		if( advanceSearchUse == false ){
			advanceSearchUse = true;
			$('#toggleAdvancedSearchBtn').text('고급검색닫기');
			$('#bidding-advanced-search').show();
		}else{
			advanceSearchUse = false;
			$('#toggleAdvancedSearchBtn').text('고급검색열기');
			$('#bidding-advanced-search').hide();
		}
	},
	clickAdvancedAMBtn : function(obj){
		var $this = $(obj);
		var btnType = $this.data('btn-type');

		if( btnType == 'add' ){
			$('#bidding-advanced-search').append( biddingFunc.makeOneAdvancedSearchRow('minus') );
		}else{
			$this.closest('.add_contents').remove();
		}
	},
	onChangeAdvancedSection : function(obj){
		var $this = $(obj);
		var optionType = $this.val();
		var $parent = $this.closest('.add_contents');
		if( optionType == 'compare' ){
			$parent.find('.not-compare').show();
		}else{
			$parent.find('.not-compare').hide();
		}
	},
	onChangeAdvancedGroupSelect : function(obj){
		var $this = $(obj);
		$currentAdvSearchRow = $this.closest('.add_contents');
		var param = "?field_name=" + $this.val();
		var dataApi = dataUrl.biddingAPI('GET', 'addSelectField', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setAdvancedSearchDataOptions);
	},
	setAdvancedSearchDataOptions : function(result){
		var $dataSelect = $currentAdvSearchRow.find('.data_select');
		var optionData = result.data;

		var options = '';
		for(var idx=0; idx<optionData.length; idx++){
			options += "<option value='"+ optionData[idx].type +"'>"+ optionData[idx].type_label +"</option>";
		}
		$dataSelect.html(options);
		$currentAdvSearchRow = null;
	},
	clickSearchKeywordBtn : function(){
		var searchKeyword = $('#bidding-default-search-keyword').val();
		var searchType = $('#bidding-default-search-type').val();
		if( searchKeyword == '' && advanceSearchUse == false){
			alert('키워드를 입력해주세요.');
			return;
		}

		if( advanceSearchUse == true ){
			var $advancedRows = $('.add_contents');
			var $row = null;
			var $field = null;
			var fieldValue = null;
			var operationValue = null;
			var valueValue = null;
			var detailValueInputCheck = false;
			var $inputs = null;

			filter_fields = '';
			filter_operations = '';
			filter_values = '';

			$.each($advancedRows, function(idx, row){
				$row = $(row);

				$field = $row.find('.type_select');
				fieldValue = $row.find('.data_select').val();
				fieldValue = (checkedType.list == 'Compare' ? fieldValue : fieldValue.substring(0, fieldValue.length-4)); // 조회 일 경우 '_org' 제거
				operationValue = $row.find('.section_select').val();

				$inputs = $row.find('.adv-srch-value');
				if( operationValue == 'compare' ){
					if( $inputs[0].value == '' || $inputs[1].value == '' ){
						detailValueInputCheck = false;
					}else{
						detailValueInputCheck = true;
						valueValue = $inputs[0].value + '/' + $inputs[1].value;
					}
				}else{
					if( $inputs[0].value == '' ){
						detailValueInputCheck = false;
					}else{
						detailValueInputCheck = true;
						valueValue = $inputs[0].value;
					}
				}

				// 상세 데이터 입력시에만 조건에 추가
				if( detailValueInputCheck ){
					filter_fields += fieldValue + ",";
					filter_operations += operationValue + ",";
					filter_values += valueValue + ",";
				}
			});
		}
		biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, searchType, searchKeyword);
		var dataApi = dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
	},
	// 검색 관련 End

}

window.biddingFunc = biddingFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/sub/biddingFunc.js